/* ============================================================
   ATLAS — VF WATCHDOG
   ------------------------------------------------------------
   RESPONSABILITÀ:
   - Monitorare i tempi di caricamento di Voiceflow
   - Rilevare situazioni di freeze / blocco prolungato
   - Attivare recovery automatico (reset / reopen VF)
   - Mostrare / nascondere overlay di sistema tramite ATLAS UI

   NON FA:
   - NON inizializza Voiceflow
   - NON gestisce stato applicativo
   - NON prende decisioni di business
   - NON modifica direttamente il DOM

   Dipende SOLO da:
   - Eventi globali (CustomEvent)
   - ATLAS.ui.overlays
============================================================ */
(function () {
  'use strict';

  if (!window.ATLAS?.ui?.overlays) {
    console.warn('[ATLAS][VF] Watchdog disabled: overlays not available');
    return;
  }

  /* ============================
     CONFIG
  ============================ */
  const LOADING_TIMEOUT = 8000;
  const FREEZE_TIMEOUT  = 12000;

  /* ============================
     INTERNAL STATE
  ============================ */
  let loadingTimer = null;
  let freezeTimer  = null;
  let freezeCount  = 0;

  /* ============================
     MINI STATE ENGINE
  ============================ */

  const STATE_KEY = '__ATLAS_FLOW_STATE';

  function saveState(partial) {
    try {
      const prev = JSON.parse(sessionStorage.getItem(STATE_KEY) || '{}');
      const next = { ...prev, ...partial, ts: Date.now() };
      sessionStorage.setItem(STATE_KEY, JSON.stringify(next));
    } catch {}
  }

  function getState() {
    try {
      return JSON.parse(sessionStorage.getItem(STATE_KEY) || '{}');
    } catch {
      return {};
    }
  }

  function clearState() {
    try { sessionStorage.removeItem(STATE_KEY); } catch {}
  }

  // 👇 intercetta ultimo messaggio agente
  window.__VF_LAST_AGENT__ = null;

  window.addEventListener('message', (ev) => {
    try {
      const d = ev.data;
      if (d?.payload?.source === 'agent') {
        window.__VF_LAST_AGENT__ = d.payload;

        // 👉 salviamo "stato minimo utile"
        saveState({
          lastAgentId: d.payload.id || null,
          lastType: d.payload.type || null
        });
      }
    } catch {}
  });

  /* ============================
     WATCHDOG LOGIC
  ============================ */

  function startLoadingWatch() {
    clearTimeout(loadingTimer);
    clearTimeout(freezeTimer);

    loadingTimer = setTimeout(() => {
      ATLAS.ui.overlays.showLoading();
    }, LOADING_TIMEOUT);

    freezeTimer = setTimeout(() => {
      if (!navigator.onLine) return;

      freezeCount++;
      console.warn('[ATLAS][VF] freeze detected:', freezeCount);

      try {
        if (freezeCount >= 2) {
          hardRecover();
        } else {
          window.voiceflow?.chat?.open?.();
        }
      } catch {}
    }, FREEZE_TIMEOUT);
  }

  function stopLoadingWatch() {
    clearTimeout(loadingTimer);
    clearTimeout(freezeTimer);

    freezeCount = 0;
    ATLAS.ui.overlays.hideLoading();
  }

  /* ============================
     HARD RECOVERY (CORE LOGIC)
  ============================ */

  function hardRecover() {
    console.warn('[ATLAS][VF] HARD RECOVERY');

    const state = getState();
    try {
      window.voiceflow?.chat?.destroy?.();
    } catch {}

    window.__ATLAS_FLAGS__.vfStarted = false;

    // 🔥 reinit completo
    window.initVF?.();

    // 🔥 reiniezione stato (QUESTA È LA CHIAVE)
    setTimeout(() => {
      try {
        const vf = window.voiceflow?.chat;
        if (!vf) return;
        vf.open?.();
        // resume base
        vf.sendEvent?.({ type: 'resume_after_reconnect' });
        // resume avanzato (state engine)
        if (state?.lastAgentId) {
          vf.sendEvent?.({
            type: 'resume_flow',
            data: { from: state.lastAgentId }
          });
        }
      
    setTimeout(() => {
      ATLAS?.ui?.toast?.show?.({
        type: 'info',
        message: 'Connessione ripristinata. Potrebbe essere necessario ripetere l’ultimo passaggio.',
        duration: 4000
      });
    }, 400);

    console.log('[ATLAS][VF] state restored', state);

  } catch (e) {
    console.warn('[ATLAS][VF] restore failed', e);
  }
 }, 1200);
}

  /* ============================
     HEALTH CHECK (SEMPLIFICATO)
  ============================ */
  setInterval(() => {
    const vf = window.voiceflow?.chat;
    if (!vf || !navigator.onLine) return;

    try {
      vf.sendEvent?.({ type: 'ping_check' });
    } catch {
      console.warn('[ATLAS][VF] broken instance → recover');
      hardRecover();
    }
  }, 6000);

  /* ============================
     EVENTS
  ============================ */
  window.addEventListener('atlas:vf:loading:start', startLoadingWatch);
  window.addEventListener('atlas:vf:loading:stop',  stopLoadingWatch);

  window.addEventListener('offline', () => {
    ATLAS.ui.overlays.showOffline();
  });

  window.addEventListener('online', () => {
    ATLAS.ui.overlays.hideOffline();
    console.log('[ATLAS][VF] back online → recover');
    hardRecover();
  });

})();